import { apiCall } from "../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);

export const submitVendorAPI = async (body) => {
  try {
    return await post("vendor", body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const saveAttachmentApi = async (id, body) => {
  try {
    return await put(`vendor/attachment_update/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const saveMSMEAttachmentApi = async (id, body) => {
  try {
    return await put(`vendor/msme_attachment_update/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const saveGSTAttachmentApi = async (id, body) => {
  try {
    return await put(`vendor/gst_attachment_update/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateVendorAPI = async (id, body) => {
  try {
    return await put(`vendor/update/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const saveBankAPI = async (id, body) => {
  try {
    return await put(`vendor/bank_details/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const saveTaxAPI = async (id, body) => {
  try {
    return await put(`vendor/tax_details/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getVendorEditApi = async (id) => {
  try {
    return await get(`vendor/edit/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const getVendorBankDetApi = async (id) => {
  try {
    return await get(`vendor/bank_details/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const getVendorTaxDeApi = async (id) => {
  try {
    return await get(`vendor/tax_details/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const getVendorGSTAttApi = async (id) => {
  try {
    return await get(`vendor/gst_attachment/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const getVendorMsmeAttApi = async (id) => {
  try {
    return await get(`vendor/msme_attachment/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
